export enum ErrorCodes {
  // Update antha-com/appserver/src/lib/middleware/apolloGraphQL.ts when adding new
  // entries here
  WORKFLOW_EDIT_CONFLICT = 'WORKFLOW_EDIT_CONFLICT',
  PROTOCOL_EDIT_CONFLICT = 'PROTOCOL_EDIT_CONFLICT',
  PROTOCOL_INSTANCE_EDIT_CONFLICT = 'PROTOCOL_INSTANCE_EDIT_CONFLICT',
}
